import { Events } from '|>/shared/events'
import { Intent } from '|>/shared/types/intent'
import { register } from '|>/shared/vjs'
import { BaseButton } from '../base'

import './close-button.css'

/**
 * Top-right close button component
 * https://github.com/videojs/video.js/blob/e78bcc7b2d829fce01451cf105b918d8feec4548/src/js/button.js
 */
@register
export class CloseButton extends BaseButton {
  override handleClick() {
    this.player_.trigger(Events.User.Intent, Intent.ClosePlayer)
    this.player_.trigger(Events.Player.Close)
  }

  override createEl(tag, props = {}, attributes = {}) {
    const el = super.createEl(tag, props, attributes)

    if (el instanceof HTMLButtonElement) {
      el.setAttribute('data-testid', 'close-button')
    }

    return el
  }
}

CloseButton.options = {
  className: 'vjs-x-close-button',
}
